import React from 'react'
import PropTypes from 'prop-types'
import DhsvBlogItem from './blogItem'
import DhsvSocialItem from './socialItem'
import DhsvPostDoubleh from './postDoublehItem'
import DhsvPostAdv from './postAdvItem'
import DhsvPostEmpty from './postEmptyItem'
import DhsvTestimonialItem from './testimonialItem'
import DhsvTeaserbox from './teaserboxItem'
import DhsvPostHighlight from './postHighlight'
import DhsvPostHighlightSlider from './postHighlightSlider'
import DhsvClientAdItem from './clientAdItem'
import DhsvExternItem from './externItem'
import InfiniteScroll from 'react-infinite-scroll-component'
import LoadingIndicator from './loading'
import DhsvPostHighlightWide from './postHighlightWide'

class DhsvBlogPostGrid extends React.Component {
  constructor(props) {
    super(props)

    this.resizeDoubleh = this.resizeDoubleh.bind(this)
  }

  componentDidMount() {
    window.dispatchEvent(new CustomEvent('scroll'))
    var postdoubleheight = $('.blog-item.post-double-height').height()
    var postemptyheight = $('.blog-item.post-empty').height()
    var doubleheight = postdoubleheight + postemptyheight + 30
    $('.blog-item.post-double-height .inner .image-double-height').css(
      'height',
      doubleheight + 'px'
    )
    window.addEventListener('resize', this.resizeDoubleh)
  }

  resizeDoubleh() {
    var postdoubleheight = $('.blog-item.post-double-height').height()
    var postemptyheight = $('.blog-item.post-empty').height()
    var doubleheight = postdoubleheight + postemptyheight + 30
    $('.blog-item.post-double-height .inner .image-double-height').css(
      'height',
      doubleheight + 'px'
    )
  }

  render() {
    const {
      readMore,
      loadMore,
      hasMore,
      posts,
      startGrid,
      teaser,
      isMD,
      current,
      strings,
      handleCategoryChange,
    } = this.props

    console.log(startGrid)
    return (
      <div>
        {startGrid.length > 0 && current.type === 'blog' ? (
          <div className="start-grid">
            {startGrid.map((item, index) => {
              const row =
                isMD && item.type != 'post_highlight_slider'
                  ? 'magazin_3_spalten'
                  : item.row
              return (
                <div className={row} key={index}>
                  {['post', 'selected_post'].includes(item.type) &&
                  item.data ? (
                    <DhsvBlogItem
                      index={index}
                      item={item.data}
                      readMore={readMore}
                      row={row}
                      handleCategoryChange={handleCategoryChange}
                    />
                  ) : item.type === 'post_advertisement' ? (
                    <DhsvPostAdv data={item.data} />
                  ) : item.type === 'post_doubleh' ? (
                    <DhsvPostDoubleh data={item.data} />
                  ) : item.type === 'post_empty' ? (
                    <DhsvPostEmpty data={item.data} />
                  ) : item.type === 'facebookfollow' ? (
                    <DhsvSocialItem data={item.data} />
                  ) : item.type === 'linkedin' ? (
                    <DhsvSocialItem data={item.data} />
                  ) : item.type === 'client_advertisement' ? (
                    <DhsvClientAdItem data={item.data} />
                  ) : item.type === 'post_highlight' ? (
                    <DhsvPostHighlight readMore={readMore} data={item.data} />
                  ) : item.type === 'post_highlight_slider' ? (
                    <DhsvPostHighlightSlider data={item.data} />
                  ) : item.type === 'post_highlight_wide' ? (
                    <DhsvPostHighlightWide data={item.data} />
                  ) : item.type === 'testimonial' ? (
                    <DhsvTestimonialItem row={row} data={item.data} />
                  ) : item.type === 'teaserbox' ? (
                    <DhsvTeaserbox row={row} data={item.data} />
                  ) : item.type === 'teaserbox_list' ? (
                    <DhsvTeaserbox row={row} data={item.data} list />
                  ) : item.type === 'extern' ? (
                    <DhsvExternItem row={row} data={item.data} />
                  ) : (
                    <div className="blog-item" />
                  )}
                </div>
              )
            })}
          </div>
        ) : null}
        {!teaser ? (
          posts.length ? (
            <InfiniteScroll
              className="post-grid"
              dataLength={posts.length}
              next={loadMore}
              hasMore={hasMore}
              endMessage={''}
              loader={<LoadingIndicator />}
              useWindow={true}
              scrollThreshold={0.65}
            >
              {posts.map((item, index) => (
                <DhsvBlogItem
                  key={index}
                  index={index}
                  item={item}
                  readMore={readMore}
                  handleCategoryChange={handleCategoryChange}
                />
              ))}
            </InfiniteScroll>
          ) : (
            <div className="no-results">{strings.noResults}</div>
          )
        ) : null}
      </div>
    )
  }
}

DhsvBlogPostGrid.propTypes = {
  isMD: PropTypes.bool,
  teaser: PropTypes.bool,
  posts: PropTypes.array,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  readMore: PropTypes.string,
  startGrid: PropTypes.array,
  current: PropTypes.object,
  strings: PropTypes.object,
  handleCategoryChange: PropTypes.func,
}

export default DhsvBlogPostGrid
